import { render, staticRenderFns } from "./MomentDetail.vue?vue&type=template&id=31a7599e&scoped=true&"
import script from "./MomentDetail.vue?vue&type=script&lang=js&"
export * from "./MomentDetail.vue?vue&type=script&lang=js&"
import style0 from "./MomentDetail.vue?vue&type=style&index=0&id=31a7599e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a7599e",
  null
  
)

export default component.exports